import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "ant-row" }
const _hoisted_2 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-6" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "ss-selecionar-empresas" }, "PERÍODO:")
], -1)
const _hoisted_4 = { class: "ant-col ant-col-xs-24 ant-col-xl-5" }
const _hoisted_5 = {
  key: 0,
  class: "ant-row"
}
const _hoisted_6 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_7 = {
  key: 0,
  class: "acoes-item"
}
const _hoisted_8 = ["onClick"]
const _hoisted_9 = {
  key: 1,
  class: "visualizar",
  title: "Importado"
}
const _hoisted_10 = { key: 1 }
const _hoisted_11 = ["title"]
const _hoisted_12 = { key: 1 }
const _hoisted_13 = ["title"]
const _hoisted_14 = ["title"]
const _hoisted_15 = {
  key: 5,
  style: {"margin-right":"5px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_busca_rapida = _resolveComponent("busca-rapida")!
  const _component_selecionar_filtro_periodo_movimento_comercial = _resolveComponent("selecionar-filtro-periodo-movimento-comercial")!
  const _component_selecionar_data_inicial_final = _resolveComponent("selecionar-data-inicial-final")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_card = _resolveComponent("card")!
  const _component_mensagem_sem_dados = _resolveComponent("mensagem-sem-dados")!
  const _component_icone = _resolveComponent("icone")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_spin = _resolveComponent("a-spin")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_card, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_busca_rapida, {
              buscaRapida: _ctx.state.valorBusca,
              "onUpdate:buscaRapida": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.valorBusca) = $event)),
              placeholder: "Digite o número de pedido, dados do emitente ou valor da NF-e...",
              onBuscarDados: _cache[1] || (_cache[1] = ($event: any) => (_ctx.buscarPedidos()))
            }, null, 8, ["buscaRapida"])
          ]),
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_selecionar_filtro_periodo_movimento_comercial, {
              valor: _ctx.state.filtroPeriodo,
              "onUpdate:valor": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.filtroPeriodo) = $event)),
              ocultarPeriodoPersonalizado: false,
              onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.buscarPedidos()))
            }, null, 8, ["valor"]),
            ((_ctx.state.filtroPeriodo === _ctx.EFiltroPeriodoMovimentoComercial.Personalizado))
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createVNode(_component_a_form_item, {
                      label: "Data Inicial e Final",
                      class: "ss-margin-campos"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_selecionar_data_inicial_final, {
                          dataInicialSelecionada: _ctx.state.dataInicial,
                          "onUpdate:dataInicialSelecionada": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.dataInicial) = $event)),
                          dataFinalSelecionada: _ctx.state.dataFinal,
                          "onUpdate:dataFinalSelecionada": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.dataFinal) = $event)),
                          onChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.buscarPedidos()))
                        }, null, 8, ["dataInicialSelecionada", "dataFinalSelecionada"])
                      ]),
                      _: 1
                    })
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_a_spin, {
      spinning: _ctx.state.importando,
      tip: "Aguarde por favor..."
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_table, {
          loading: _ctx.state.buscandoPedidos,
          columns: _ctx.state.colunasGrade.filter(item => item.visible),
          "data-source": _ctx.state.pedidos,
          rowKey: "codigo",
          pagination: false,
          size: "small",
          rowClassName: "ss-table-campos",
          bordered: ""
        }, {
          emptyText: _withCtx(() => [
            _createVNode(_component_mensagem_sem_dados, { mensagem: "Nenhuma Nota fiscal foi encontrada!" })
          ]),
          bodyCell: _withCtx(({ column, record }) => [
            (column.key === 'acoes')
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  ((!record.importado))
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        class: "visualizar",
                        title: "Importar",
                        onClick: ($event: any) => (_ctx.importarPedido(record.codigo))
                      }, [
                        _createVNode(_component_icone, {
                          style: {"font-size":"18px"},
                          nome: "download"
                        })
                      ], 8, _hoisted_8))
                    : _createCommentVNode("", true),
                  ((record.importado))
                    ? (_openBlock(), _createElementBlock("a", _hoisted_9, [
                        _createVNode(_component_icone, {
                          style: {"font-size":"18px"},
                          nome: "correto-circulo"
                        })
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : (column.key === 'Fornecedor')
                ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_ctx.UtilitarioMascara.mascararCPFOuCNPJ(record.cpfCnpjFornecedor)) + " " + _toDisplayString(record.nomeFornecedor), 1))
                : (column.key === 'NumeroPedido')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                      (record.numeroPedido > 0)
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 0,
                            title: record.numeroPedido
                          }, _toDisplayString(record.numeroPedido), 9, _hoisted_11))
                        : (_openBlock(), _createElementBlock("span", _hoisted_12, "-"))
                    ], 64))
                  : (column.key === 'DataCriacao')
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 3,
                        title: _ctx.UtilitarioData.aplicaFormatoData(record.dataCriacao)
                      }, _toDisplayString(_ctx.UtilitarioData.aplicaFormatoData(record.dataCriacao)), 9, _hoisted_13))
                    : (column.key === 'DataPrevisaoEntrega')
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 4,
                          title: _ctx.UtilitarioData.aplicaFormatoData(record.dataPrevisaoEntrega)
                        }, _toDisplayString(_ctx.UtilitarioData.aplicaFormatoData(record.dataPrevisaoEntrega)), 9, _hoisted_14))
                      : (column.key === 'TotalPedido')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(_ctx.UtilitarioMascara.mascararValor(record.totalPedido, 2, true)), 1))
                        : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["loading", "columns", "data-source"])
      ]),
      _: 1
    }, 8, ["spinning"])
  ]))
}